import React from 'react';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';
import ButtonRounded from 'client/components/common/button-rounded';
import ChannelCover from 'client/components/common/channel-cover';

export default class ChannelGrid extends Base {
  constructor(props) {
    super(props);
    this.state = {
      css: {
        height: '0px',
      },
      currentlyHovering: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  @autobind
  onResize() {
    let grid = document.getElementsByClassName('channel-grid');
    let height = grid[0].clientWidth / 2;
    this.setState({
      css: {
        height: height + 'px',
      },
    });
  }

  @autobind
  onHover(e) {
    if (e && e.currentTarget) {
      this.setState({
        currentlyHovering: parseInt(e.currentTarget.id),
      });
    }
  }

  getZIndex(channelIndex) {
    if (channelIndex === this.state.currentlyHovering) {
      return {
        zIndex: 1000,
      };
    } else {
      return {
        zIndex: 0,
      };
    }
  }

  render() {
    let channels = this.props.channels;
    let has2rows = 'rows' in this.props && this.props.rows == 2;
    let gridStyle = this.state.css;

    let firstRow = (
      <div className="row" style={gridStyle}>
        <ChannelCover
          id="0"
          onMouseOver={this.onHover}
          model={channels[0]}
          showInfo="true"
          addClassName="col"
          style={this.getZIndex(0)}
        />
        <div className="col">
          <div className="row">
            <ChannelCover
              id="1"
              onMouseOver={this.onHover}
              model={channels[1]}
              showInfo="true"
              addClassName="col channel-cover-small"
              style={this.getZIndex(1)}
            />
            <ChannelCover
              id="2"
              onMouseOver={this.onHover}
              model={channels[2]}
              showInfo="true"
              addClassName="col channel-cover-small"
              style={this.getZIndex(2)}
            />
          </div>
          <div className="row">
            <ChannelCover
              id="3"
              onMouseOver={this.onHover}
              model={channels[3]}
              showInfo="true"
              addClassName="col channel-cover-small"
              style={this.getZIndex(3)}
            />
            <ChannelCover
              id="4"
              onMouseOver={this.onHover}
              model={channels[4]}
              showInfo="true"
              addClassName="col channel-cover-small"
              style={this.getZIndex(4)}
            />
          </div>
        </div>
      </div>
    );

    let secondRow = '';
    if (has2rows) {
      secondRow = (
        <div className="row" style={gridStyle}>
          <div className="col">
            <div className="row">
              <ChannelCover
                id="5"
                onMouseOver={this.onHover}
                model={channels[5]}
                showInfo="true"
                addClassName="col channel-cover-small"
                style={this.getZIndex(5)}
              />
              <ChannelCover
                id="6"
                onMouseOver={this.onHover}
                model={channels[6]}
                showInfo="true"
                addClassName="col channel-cover-small"
                style={this.getZIndex(6)}
              />
            </div>
            <div className="row">
              <ChannelCover
                id="7"
                onMouseOver={this.onHover}
                model={channels[7]}
                showInfo="true"
                addClassName="col channel-cover-small"
                style={this.getZIndex(7)}
              />
              <ChannelCover
                id="8"
                onMouseOver={this.onHover}
                model={channels[8]}
                showInfo="true"
                addClassName="col channel-cover-small"
                style={this.getZIndex(8)}
              />
            </div>
          </div>
          <ChannelCover
            id="9"
            onMouseOver={this.onHover}
            model={channels[9]}
            showInfo="true"
            addClassName="col"
            style={this.getZIndex(9)}
          />
        </div>
      );
    }

    return (
      <div className={this.css()}>
        {firstRow}
        {secondRow}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/common/channel-grid/channel-grid.es6